<ng-container *transloco="let t">
  <main
    class="customer-reviews-component"
    [class.mobile]="(biggerThan$ | async)?.sm"
    [class.xs]="(biggerThan$ | async)?.xs"
    [class.single-header]="(biggerThan$ | async)?.mobileL">
    <div class="wrapper scroll" id="mainAppScroll">
      <div class="content">
        <div class="header">
          <div class="image-fit-wrapper">
            <app-picture
              class="image"
              [lazyLoad]="false"
              [pictureUrl]="imageBannerUrl"
              [alt]="t('featured_banner_title')"></app-picture>

            <span class="fixed-space-16" aria-hidden="true"></span>

            <h1>Popsy {{ t('label_customer_reviews') }}</h1>
            @if (language) {
              <span
                >Is Popsy reliable and trustworthy? Is Popsy legit? Don't just take our
                word for it - read it from our customers!</span
              >
            } @else {
              <span
                >مراجعات عملاء بوبسي هل بوبسي موثوق بها وجديرة بالثقة ؟ هل بوبسي شرعية ؟
                لا تستند إلى ما نقوله فقط - اقرأها في تقييمات عملائنا!
              </span>
            }
            <span class="fixed-space-8" aria-hidden="true"></span>
            <button class="button popsy-button-primary" (click)="navigateToProducts()">
              <span>{{ t('label_shop_with_confidence') }}</span>
              <span class="fixed-space-8" aria-hidden="true"></span>
              <popsy-icon-keyboard-arrow-right
                class="icon gray-light"
                [class.rtl]="rtlMode"></popsy-icon-keyboard-arrow-right>
            </button>
          </div>
        </div>
        <div class="reviews">
          <!-- Slider Display-->
          <swiper
            class="review-swiper swiper"
            [class.mobile]="!(biggerThan$ | async)?.mobileS"
            [loop]="true"
            [autoplay]="{ delay: 6000, pauseOnMouseEnter: true }"
            [zoom]="false"
            [hashNavigation]="{ watchState: true }"
            [spaceBetween]="48"
            [slidesPerView]="1"
            [breakpoints]="{
              '560': {
                slidesPerView: 2,
                spaceBetween: 40
              },
              '1024': {
                slidesPerView: 3,
                spaceBetween: 40
              }
            }"
            [centeredSlides]="true"
            [initialSlide]="0"
            [navigation]="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }">
            @for (review of highlightReviews; track review) {
              <ng-template swiperSlide>
                <div class="slide">
                  <span class="row rating-wrap justify-center p-16">
                    @for (n of range(review.rating); track n) {
                      <popsy-icon-star-filled
                        class="icon star-icon gold"></popsy-icon-star-filled>
                    }
                  </span>
                  <span class="col description">
                    {{ review?.description }}
                  </span>
                  <div aria-hidden="true" class="dynamic-space"></div>
                  <div class="avatar-image">
                    <img
                      #image
                      class="image"
                      [src]="review.picUrl"
                      [alt]="review.name || 'picture'"
                      [title]="review.name || 'picture'" />
                  </div>
                  <h3>{{ review.name }}</h3>
                  <span class="small description margin-0-auto">{{
                    review.subName
                  }}</span>
                  <span class="fixed-space-4" aria-hidden="true"></span>

                  <span class="model-wrap flex">
                    <span class="small">{{ t('label_bought') }}</span>
                    <span class="fixed-space-8" aria-hidden="true"></span>
                    <span (click)="navigateToModel(review.model)" class="link small">
                      {{ review.model }}
                    </span>
                  </span>
                </div>
              </ng-template>
            }
          </swiper>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
      <app-subscribe-banner />
      <span class="fixed-space-64" aria-hidden="true"></span>
    </div>
  </main>
</ng-container>
